import React from 'react'
import { Icon } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import { translate } from '@brainstud/react-tbl/themes/pgw/v1/translations'
import './Loading.css'

const Loading = props => (
  <div className="Loading">
    {!props.done && <span className="_animation" />}
    {props.done &&
      <div>
        <Icon name="info" size="large" />
        <small>{translate('app.loadingError')}</small>
      </div>
    }
  </div>
)

export default Loading